import { func, number } from "prop-types";
import { SESSION_PLAYER_SPEEDS } from "@tools/SessionPlayer/utils";
import { IconButton } from "@material-ui/core";
import classnames from "classnames";

export const SpeedButtons = ({
  playSpeed,
  setPlaySpeed,
}) => (
  <>
    {
      SESSION_PLAYER_SPEEDS.map((speed) => (
        <IconButton
          key={speed}
          color="inherit"
          onClick={() => setPlaySpeed(speed)}
          className={classnames("mx-1 text-sm font-bold", playSpeed === speed && "color-primary")}
        >
          {`${speed}x`}
        </IconButton>
      ))
    }
  </>
)

SpeedButtons.propTypes = {
  playSpeed: number.isRequired,
  setPlaySpeed: func.isRequired,
}